<template>
  <div>
    <Row v-if="bianse==0">
        <div v-if="this.$route.name!='article'" :id="id" >
          <Header/>
          <Affix :offset-top="700" v-if="topHeight>50 & pingmuWidth>1000 " >
            <div style="position:absolute;bottom: 0;left: 95%;right: 0;z-index:100">
                <div @click="goTop"class="top"></div>
                <div @click="goHome" class="top2"></div>
                <div @click="goBottom" class="top3"></div>
            </div>
          </Affix>
          <router-view/>
          <Footer/>
        </div>
        <div v-else>
          <router-view />
          <Affix :offset-bottom="50"  v-if="this.$route.name!='article'">
              <div style="position:absolute;bottom: 0;left: 85%;right: 0;z-index:100">
                  <div @click="goHome" class="top2"></div>
              </div>
          </Affix>
        </div>
    </Row>
    <Row v-else>
        <div v-if="this.$route.name!='article'" :id="id" class="bianse">
          <Header/>
          <Affix :offset-top="700" v-if="topHeight>50& pingmuWidth>1000">
            <div style="position:absolute;bottom: 0;left: 95%;right: 0;z-index:100">
                <div @click="goTop"class="top"></div>
                <div @click="goHome" class="top2"></div>
                <div @click="goBottom" class="top3"></div>
            </div>
          </Affix>
          <router-view/>
          <Footer/>
        </div>
        <div v-else>
          <router-view />
        </div>
    </Row>
      
  </div>
</template>
<script>
import {xxShouYeOther} from '@/api/index'
import Footer from '@/components/footer.vue'
import Header from '@/components/header.vue'

export default {
  name: 'App',
  data(){
    return{
      topHeight:0,
      organ_id:'',
      bianse:0,
      id:'app',
      pingmuWidth:0
    }
  },
  components: {
    Footer,
    Header,
  },
  methods:{
    goBottom(){
      window.scrollTo(0, document.body.scrollHeight);
    },
    goTop(){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    goHome(){
      this.$router.push({name:'Home',query:{}});
    },
    handleScrollx() {
      this.topHeight = window.pageYOffset;//滚动高度大于50，显示回到顶部底部
    },
  },
  mounted(){
    this.organ_id=this.GLOBAL.organ_id;
    this.pingmuWidth=document.body.clientWidth
    if(this.pingmuWidth>1000){
      this.id='app'
    }else{
      this.id='app2'
    }
    window.addEventListener('scroll',this.handleScrollx,true)
    xxShouYeOther({organ_id:this.organ_id}).then(res=>{
      this.bianse = res.data.data.bianse
    })
  },
  created(){
    window.addEventListener('scroll',this.handleScrollx,true)
  }
  
}
</script>
<style lang="less">

#app {
  background: url(assets/image/bj.png) no-repeat;
  background-size: 100% 100%;
  width:100%;
  height:1200px
}
#app2 {
  background: url(assets/image/bj-app.png) no-repeat;
  background-size: 100% 100%;
  width:100%;
  height:1200px
}
.bianse{
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
}

.top{
    background: url(assets/image/backTop.png) no-repeat;
    background-size: 100% 100%;
    width:45px;
    height: 45px;
    cursor:pointer
}
.top2{
    background: url(assets/image/backHome.png) no-repeat;
    background-size: 100% 100%;
    width:45px;
    height: 45px;
    margin-top: 10px;
    cursor:pointer
}
.top3{
    background: url(assets/image/backBottom.png) no-repeat;
    background-size: 100% 100%;
    width:45px;
    height: 45px;
    margin-top: 10px;
    cursor:pointer
}
</style>
